import { Injectable } from '@angular/core';
import { catchError, map, Observable, switchMap } from 'rxjs';
import {
  ModifyMotorIframe,
  ModifyMotorsURLIFrameRequest,
  ModifyMotorsURLIFrameRequestConfig,
} from './modify-motors.model';
import { OccEndpointsService, TranslationService, UserIdService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { failStatus, successStatus } from '../../../../../core/models/request-status.model';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ModifyMotorsAdapter {
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    private translationService: TranslationService,
    private userIdService: UserIdService,
    private sanitize: DomSanitizer,
  ) {}

  getIframeURL(config: ModifyMotorsURLIFrameRequestConfig): Observable<ModifyMotorsURLIFrameRequest> {
    return this.userIdService.getUserId().pipe(
      switchMap(userId => {
        const url = this.occEndPointService.buildUrl('getIframeModiFyMotors', {
          urlParams: {
            userId,
          },
          queryParams: config,
        });

        return this.http.get(url).pipe(
          map((response: any) => {
            return {
              iframeConfigs: this.normalizeIframeResponse(response),
              ...successStatus,
            };
          }),
          catchError(() => {
            return this.translationService.translate('generic.error').pipe(
              map(textError => ({
                message: textError,
                ...failStatus,
              })),
            );
          }),
        );
      }),
    );
  }

  normalizeIframeResponse(response: any): ModifyMotorIframe {
    return {
      czURL: response?.czURL,
      //initParams: this.sanitize.bypassSecurityTrustResourceUrl(response?.initParams),
			initParams: response?.initParams,
      transactionID: response?.transactionID || '',
    };
  }
}
